module.exports = __webpack_public_path__ + "static/media/computrain.6e9d7ad0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/computrain.webp
// module id = 649
// module chunks = 0